import flatpickr from "flatpickr";

const initFlatpickr = (classname, options) => {
  flatpickr(classname, options);
};

export { initFlatpickr };
